// ABOUTME: Business-level (BusinessRole) permission helpers.
// Mirrors the backend's ROLE_WEIGHT ordering (app/rbac.py) so the frontend
// never maintains a second, possibly-drifting copy of the role hierarchy.

export type BusinessRole = 'owner' | 'admin' | 'member'

// Keep in lockstep with ROLE_WEIGHT in app/rbac.py: member=1, admin=2, owner=3.
const BUSINESS_ROLE_WEIGHT: Record<BusinessRole, number> = {
  member: 1,
  admin: 2,
  owner: 3,
}

/**
 * True when `role` meets or exceeds `minimum` in the BusinessRole hierarchy.
 *
 * `role` is `null`/`undefined` whenever the caller's business_role hasn't
 * been resolved yet (e.g. stale session, missing membership row) — always
 * treated as below every role, i.e. fail closed rather than assume admin.
 */
export function hasBusinessRoleAtLeast(
  role: BusinessRole | null | undefined,
  minimum: BusinessRole
): boolean {
  if (!role) return false
  return BUSINESS_ROLE_WEIGHT[role] >= BUSINESS_ROLE_WEIGHT[minimum]
}
